import { render, staticRenderFns } from "./AuthorityError.vue?vue&type=template&id=66b6e1a6&scoped=true"
import script from "./AuthorityError.vue?vue&type=script&lang=js"
export * from "./AuthorityError.vue?vue&type=script&lang=js"
import style0 from "./AuthorityError.vue?vue&type=style&index=0&id=66b6e1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b6e1a6",
  null
  
)

export default component.exports